import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Guid from "_shared/guids/guid";
import IndividualAvatar from "marketplace/_views/avatars/individual-avatar";
import { getIndividualByUserId } from "marketplace/individuals/_stores/individuals-redux-slice";
import { useSelector } from "react-redux";
import Session from "users/__session/session";
import NetworkedGroup from "users/networking/groups/networked-group";

interface AvatarGroupProps {
  group: NetworkedGroup;
  session: Session;
  avatarGroupMax?: number;
}

const DEFAULT_AVATAR_GROUP_MAX = 5;

export default function NetworkedGroupAvatarGroup(props: Readonly<AvatarGroupProps>) {

  const { group, session, avatarGroupMax } = props;

  const individuals = group?.memberUserIds?.map((userId) => useSelector(getIndividualByUserId(userId)));

  return (
    <AvatarGroup max={avatarGroupMax ?? DEFAULT_AVATAR_GROUP_MAX}>
      {individuals?.map((individual) => {
        if (!individual) return <Avatar key={Guid.generate().value} />;
        return (
          <IndividualAvatar
            key={individual?.userId?.value}
            individual={individual}
            session={session}
          />
        );
      })}
    </AvatarGroup>
  );
}
